import ReactPlayer from "react-player/lazy";
import { BASE_URL } from "constants/env";
import styled, { css, SimpleInterpolation } from "styled-components/macro";
import colors from "constants/colors";

export const InnterContent = styled.div<{ ratio?: number }>`
  ${({ ratio }): SimpleInterpolation =>
    ratio &&
    css`
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    `};
`;

type ContainerType = {
  playing?: boolean;
  thumbnail?: string;
  ratio?: number;
};
export const Container = styled.div<ContainerType>`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  &::before {
    content: "";
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;

    ${({ playing, thumbnail }): SimpleInterpolation =>
      !playing &&
      css`
        background-image: url("${BASE_URL}/${thumbnail}");
      `}

    ${({ ratio }): SimpleInterpolation =>
      ratio
        ? css`
            display: block;
            width: 100%;
            padding-bottom: ${`${ratio * 100}%`};
          `
        : css`
            position: absolute;
            width: 100%;
            height: 100%;
          `}
  }
`;

export const ReactPlayerExtend = styled(ReactPlayer)`
  iframe {
    min-height: 100%;
  }
`;

type PlaceholderType = {
  hideIcon?: boolean;
  fillPlaceholder?: boolean;
};
export const Placeholder = styled.div<PlaceholderType>`
  position: absolute;
  z-index: 100;
  top: 50%;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transform: translate(-50%, -50%);

  ${({ fillPlaceholder }) =>
    fillPlaceholder
      ? css`
          width: 100%;
          height: 100%;
        `
      : css`
          width: 107px;
          height: 107px;
        `};

  ${({ hideIcon }) =>
    !hideIcon &&
    css`
      &:before {
        content: "";
        color: #d5d5d5;
        position: absolute;
        font-size: 32px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) scale(1);
        transition: 0.45s cubic-bezier(0.075, 0.82, 0.165, 1);
        border: 2px solid #d5d5d5;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: 7px;
        padding-top: 3px;
      }
      &:after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(calc(-50% + 12px), -50%) scale(1.75, 1);
        transition: 0.45s cubic-bezier(0.075, 0.82, 0.165, 1);
        border: 11px solid transparent;
        border-left-color: #d5d5d5;
        width: 0;
        height: 0;
      }

      &:hover {
        &:before {
          transform: translate(-50%, -50%) scale(1.1);
          color: ${colors.richElectricBlue};
          border: 2px solid ${colors.richElectricBlue};
        }
        &:after {
          transform: translate(calc(-50% + 12px), -50%) scale(1.75, 1);
          border-left-color: ${colors.richElectricBlue};
        }
      }
    `}
`;
export const PlayButton = styled.div`
  width: 30px;
  height: 30px;
`;
